import { NumberRangeFilter } from 'src/components/Filters/NumberRangeFilter';
import { PosMultiSelect } from 'src/core/POS/PosMultiSelect';
import { TooltipPopover } from 'src/core/ui';
import { ColumnFilterButton } from 'src/core/ui/ColumnFilterButton';
import { ContentId } from 'src/utils/constants/contentId';

import { useColumnFilter } from '../hooks/useColumnFilter';
import { TableHeaderProps } from './ColumnHeader.types';

export const ColumnHeaderFilter = ({ table, header }: TableHeaderProps) => {
  const {
    isColumnFilterActive,
    columnFilterOptionsContent,
    canMultiSelect,
    filterValue,
    setColumnFilterValue,
  } = useColumnFilter(table, header);

  return (
    <>
      {canMultiSelect ? (
        <PosMultiSelect
          values={(filterValue ?? []) as string[]}
          onChange={({ newValues }) => setColumnFilterValue(newValues)}
          onClick={(e) => e.stopPropagation()}
          enableEmptySelection
          valueOptionsContent={columnFilterOptionsContent}
          showSelectedOptionsFirst
          childrenAsTrigger
          placeholderText={ContentId.All}
          searchable={Object.keys(columnFilterOptionsContent).length > 10}
        >
          <ColumnFilterButton isActive={isColumnFilterActive} />
        </PosMultiSelect>
      ) : (
        <TooltipPopover
          triggerContent={
            <ColumnFilterButton isActive={isColumnFilterActive} />
          }
        >
          <NumberRangeFilter
            filterValue={{
              min: (filterValue as [number, number])?.[0],
              max: (filterValue as [number, number])?.[1],
            }}
            setFilterValue={(value) => {
              if (value == null) {
                setColumnFilterValue(undefined);
              }
              setColumnFilterValue([value.min, value.max]);
            }}
          />
        </TooltipPopover>
      )}
    </>
  );
};
